<template>
  <v-card class="helmi-card">
    <div class="helmi-card-title pb-0 pl-6 pt-6">
      Muokkaa tietoja
    </div>
    <v-card-text>
      <v-select
        v-if="currentProperty.osakevaikiinteisto > 0"
        v-model="assetDetails.asset"
        :items="assetTypes"
        hide-details
        label="Kohdetyyppi"
        class="mt-4"
        outlined
      />
      <v-select
        v-if="currentProperty.osakevaikiinteisto > 0"
        v-model="assetDetails.transferType"
        :items="transferTypes"
        hide-details
        label="Luovutuksen tyyppi"
        class="mt-4"
        outlined
      />
      <p class="mt-4 mb-0 body-1">
        Osittain verovapaa kauppa?
      </p>
      <p class="caption mb-0 mt-2 font-weight-regular">
        Se osa kauppahinnasta tai muusta vastikkeesta,
        josta myös varainsiirtoverosta vapautettu ostaja
        maksaa varainsiirtoveroa
      </p>
      <v-text-field
        v-model="assetDetails.portionOfSellingPrice"
        type="number"
        append-icon="euro_symbol"
        outlined
        dense
        min="0"
        hide-details
      />
      <v-alert
        dense
        class="mt-4"
        type="info"
        text
      >
        Muut kohteen tiedot muutettavissa toimeksiannon muokkauksen kautta.
      </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="primary"
        text
        @click="closeDialog()"
      >
        Peruuta
      </v-btn>
      <v-btn
        color="primary"
        text
        :loading="sending"
        @click="saveTaxTransferDetails()"
      >
        Tallenna
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ModifyTaxTransfer',
  props: {
    assetDetails: {
      type: Object,
      default: () => ({
        asset: 1,
        portionOfSellingPrice: 0,
      }),
    },
  },
  data: () => ({
    sending: false,
    transferTypes: [
      {
        text: 'Kauppa',
        value: 1,
      },
      {
        text: 'Vaihto',
        value: 2,
      },
      {
        text: 'Muu',
        value: 3,
      },
    ],
  }),
  computed: {
    ...mapState({
      currentProperty: state => state.currentProperty,
      taxDetails: state => state.taxDetails,
    }),
    assetTypes() {
      return [
        {
          text: `Osakehuoneisto ${this.taxDetails.varainsiirtoveroprosentti}% (oletus)`,
          value: 1,
        },
        {
          text: `Parkkipaikka/varasto ${this.taxDetails.varainsiirtoveroprosentti}%`,
          value: 2,
        },
        {
          text: `Lomaosake ${this.taxDetails.varainsiirtoveroprosentti}%`,
          value: 4,
        },
      ];
    },
  },
  created() {
    if (!this.assetDetails.asset) {
      this.assetDetails.asset = 1;
      this.assetDetails.transferType = 1;
    }
  },
  methods: {
    ...mapActions({
      modifyTaxTransfer: 'modifyTaxTransfer',
    }),
    closeDialog() {
      this.$bus.$emit('closeTaxTransferDialog');
    },
    async saveTaxTransferDetails() {
      this.sending = true;
      await this.modifyTaxTransfer({
        id: this.$route.params.propertyId,
        details: this.assetDetails,
      });
      this.sending = false;
      this.$bus.$emit('closeTaxTransferDialog');
      this.$bus.$emit('reload');
    },
  },
};
</script>
